(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref085"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref085"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lcVoW", function(module, exports) {
$parcel$extendImportMap({
    "3kbvJ": "immutable/js/ua.19a5d1d9.js"
});

});

parcelRegister("ICtri", function(module, exports) {

module.exports = (parcelRequire("eIHV7"))($parcel$resolve("3kbvJ")).then(()=>parcelRequire('SQzZU'));

});
parcelRegister("eIHV7", function(module, exports) {
"use strict";

var $7tcwK = parcelRequire("7tcwK");
module.exports = $7tcwK(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7tcwK", function(module, exports) {
"use strict";
var $5704f579d2bb6949$var$cachedBundles = {};
var $5704f579d2bb6949$var$cachedPreloads = {};
var $5704f579d2bb6949$var$cachedPrefetches = {};
function $5704f579d2bb6949$var$getCache(type) {
    switch(type){
        case 'preload':
            return $5704f579d2bb6949$var$cachedPreloads;
        case 'prefetch':
            return $5704f579d2bb6949$var$cachedPrefetches;
        default:
            return $5704f579d2bb6949$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5704f579d2bb6949$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRequire("lcVoW");
})();
const main = async ()=>{
    try {
        const { default: UA } = await parcelRequiref085("ICtri");
        // Call it based on UA
        const ua = new UA();
        switch(true){
            case ua.os === UA.OS.Android:
                window.location.href = 'users-android.html';
                break;
            case ua.os === UA.OS.iOS:
                window.location.href = 'users-ios.html';
                break;
            case ua.browser === UA.Browser.Firefox:
                window.location.href = 'users-firefox.html';
                break;
            case ua.browser === UA.Browser.Chromium:
                window.location.href = 'users-chrome.html';
                break;
            default:
                break;
        }
    } catch (error) {
        console.warn('Failed to load UA Detection:', error);
    }
};
main();

//# sourceMappingURL=group-selection.dcb2a75b.js.map
